var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.102 1.9h-15.2v11.4h4.035l.551 3.091 4.706-3.091h5.908V1.9z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 0H1.9C.852 0 0 .852 0 1.9v11.4c0 1.048.852 1.9 1.9 1.9h2.85v3.579l5.963-3.579H17.1c1.048 0 1.9-.852 1.9-1.9V1.9C19 .852 18.148 0 17.1 0zm0 13.3h-6.913L6.65 15.421V13.3H1.9V1.9h15.2v11.4z",
    fill: "#AAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4.75h9.5v1.9h-9.5v-1.9zm0 3.8h6.65v1.9H4.75v-1.9z",
    fill: "#AAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default ForwardRef;